module.exports = __webpack_public_path__ + "static/img/CC1.bccf798.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/CC1.png
// module id = bUv8
// module chunks = 0